import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Table } from 'primeng/table';
import { UserWalletService } from 'src/app/services/userWallet.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { LazyLoadEvent } from 'primeng/api';
import { saveAs } from 'file-saver/src/FileSaver';
import * as moment from "moment";
import { environment } from 'src/environments/environment';
import * as JSZip from 'jszip';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { Dropdown } from "primeng/dropdown";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-credit-note',
  templateUrl: './credit-note.component.html',
  styleUrls: ['./credit-note.component.scss'],
  providers: [MessageService, ConfirmationService]
})

export class CreditNoteComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>(); 
  public walletlist: any = [];
  public downloadwalletlist: any = [];
  public loading: boolean;
  public totalRecords = 0;
  errorMessage: string;
  public loggedInUser;
  paginationOption;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  searchby;
  searchBy: any[];
  username: string;
  totalCoins;
  totalDeductedCoin;
  totalAvailableCoins;
  totalCash;
  totalDeductedCash;
  totalAvailableCash;
  description:any;
  endDate: Date;
  downloadFlg: boolean;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  public userId;
  public loggedInUserId;
  public loggedInUserData;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  constructor(
    private tokenStorageService: TokenStorageService,
    private userWalletService: UserWalletService,
    private router: Router,
    private http: HttpClient,
    private messageService: MessageService, private confirmationService: ConfirmationService, private activeroute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.loggedInUserData = this.tokenStorageService.getUser();
    this.loggedInUserId = this.loggedInUserData.userdata['id'];
    console.log(this.loggedInUserId);
    this.userId = this.activeroute.snapshot.params.id;
    this.searchBy = [
      { label: 'Created On', value: "created_at" }
    ];

    this.description = [
      { label: "Tournament Registration Fees", value: "Tournament Registration Fees" },
      { label: "Player registered for Tournament", value: "Player registered for Tournament" },
      { label: "Find a Partner Fees", value: "Find a Partner Fees" },
      { label: "Cash Credited On schdeule Registration", value: "Cash Credited On schdeule Registration" },

    ];
    this.downloadFlg = false;
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt.filter('', 'id', 'contains');
    this.dt.filter('', 'userName', 'contains');
    this.dt.filter('', 'coins', 'contains');
    this.dt.filter('', 'amount', 'contains');
    this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = "";
    }
  }
  addNewWallet() {
    this.router.navigate(['/manage/customer/user/wallet/add/' + this.userId]);
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }
  loadWalletHistory(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false&showAll=true&filterByAction=ADD"; //&filterByUserid=" + this.userId;
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 100;
    }
    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (event.filters != undefined && event.filters["id"] != undefined) {
      params += "&filterById=" + event.filters["id"].value;
    }
    if (event.filters != undefined && event.filters["userName"] != undefined) {
      params += "&filterByName=" + event.filters["userName"].value;
    }
    if (event.filters != undefined && event.filters["amount"] != undefined) {
      params += "&filterByAmount=" + event.filters["amount"].value;
    }

    if (event.filters != undefined && event.filters["description"] != undefined) {
      params += "&filterByDescription=" + event.filters["description"].value;
    }
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.userWalletService.getUserWalletList(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.loading = false;
        this.walletlist = data.data.items;
        this.totalRecords = data.data.totalCount;

      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
    
 
  exportExcel() {
    this.downloadFlg = true;
    this.loadWalletHistory(this.lastTableLazyLoadEvent);
    var propertiesRemove = ['tournamentplayerdata', 'contestdata', 'userId', 'status', 'created_by', 'createdBy', 'updatedby', 'disable', 'updated_at','invoiceData','userData'];
    this.downloadwalletlist = this.walletlist;
    this.downloadwalletlist.forEach(function (item) {
      if (item.created_at != '') {
        item['created_at'] = moment(item.created_at).format('DD-MM-YYYY');
      }
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });

    const columnMapping = {
      'userName': 'User Name',
      'id': 'ID',
      'wallettype': 'Wallet Type',
      'invoiceFile': 'Invoice File',
      'amount': 'Amount',
      'description': 'Description',
      'action': 'Action',
      'created_at': 'Created At',
      'creditInvoiceId': 'Invoice ID',
      'ProductHSN': 'Product HSN',
      'ProductQuantity': 'Product Quantity',
      'ProductRate': 'Product Rate',
      'totalProductAmount': 'Total Product Amount',
      'igstPercentage': 'IGST Percentage',
      'igstAmount': 'IGST Amount',
      'sgstPercentage': 'SGST Percentage',
      'sgstAmount': 'SGST Amount',
      'cgstPercentage': 'CGST Percentage',
      'cgstAmount': 'CGST Amount',
      'totalTaxableAmount': 'Total Taxable Amount',
      'totalGstAmount': 'Total GST Amount',
      'placeOfSupply': 'Place of Supply'
    };
  
    import("xlsx").then(xlsx => {
      const downloadwalletlistWithHeaders = this.downloadwalletlist.map(item => {
        const newItem = {};
        for (const key in item) {
          if (columnMapping.hasOwnProperty(key)) {
            newItem[columnMapping[key]] = item[key];
          }
        }
        return newItem;
      });
  
      const worksheet = xlsx.utils.json_to_sheet(downloadwalletlistWithHeaders);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
      this.saveAsExcelFile(excelBuffer, "Wallet History");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  deleteUserWalletEntry(userWalletEntry) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this entry ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        var disableStatus;
        if (userWalletEntry.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        var userWalletEntryData = '{"disable":' + disableStatus + '}';
        this.userWalletService.updateUserWallet(userWalletEntry.id, userWalletEntryData).pipe(takeUntil(this.destroy$)).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Wallet Entry Deleted', life: 3000 });
            this.loadWalletHistory(this.lastTableLazyLoadEvent);
          },
          err => {
            this.loadWalletHistory(this.lastTableLazyLoadEvent);
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }
  downloadPdf(invoiceFile) {
    window.open(invoiceFile);
  }

  generateAndDownloadZip() {
    const zip = new JSZip();
    this.downloadwalletlist = this.walletlist;
    const pdfObservables = [];

    this.downloadwalletlist.forEach((el) => {
      if(el.creditInvoiceFile){
        pdfObservables.push(
          this.http.get(el.creditInvoiceFile, { responseType: 'blob' })
        );
      }
     
    });

    forkJoin(pdfObservables).pipe(takeUntil(this.destroy$)).subscribe((pdfBlobs:any) => {
      console.log('pdfBlobs : ',pdfBlobs);
      pdfBlobs.forEach((pdfBlob, index) => {
        zip.file(`${this.downloadwalletlist[index].id}.pdf`, pdfBlob);
      });    
      zip.generateAsync({ type: 'blob' }).then((blob) => {
        saveAs(blob, `${new Date().getTime()}.zip`);
      });
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
